// @flow
import React, { Fragment } from 'react';
import Image from 'components/base/Image'
import type { PostItem } from 'store/modules/listing';
import { resizeImage, numberWithCommas } from 'lib/common';
import { Link } from 'react-router-dom';
import './SearchResultItem.scss';

type Props = {
  post: PostItem,
  menu: string,
};

const SearchResultItem = ({ post, menu }: Props) => {
  const { title, username, thumbnail, price, supplier, url_slug, _formatted } = post;
  const nextLink =
    menu === 'posts' ? `/@${username}/${url_slug}` : `/@${username}/${menu}/${url_slug}`;
  return (
    <div className="SearchResultItem">
      <Link to={nextLink}>
        <div className="mini-postcard">
          {thumbnail && (
            <Fragment>
              <div className="thumbnail">
                <Image
                  src={resizeImage(thumbnail, 150, 150)}
                  alt="thumbnail"
                  fallbackSrc="https://images.cacheby.com/no_image_2.png"
                />
              </div>
              <div className="separator" />
            </Fragment>
          )}
          <div className="post-info">
            <span className="brand-name">{supplier}</span>
            {_formatted && _formatted.title ?
              <h4 className="title" dangerouslySetInnerHTML={{ __html: _formatted.title }}></h4> :
              <h4>{title}</h4>
            }
            {_formatted && _formatted.part_number && (
              <span className="part-number" dangerouslySetInnerHTML={{ __html: _formatted.part_number }}></span>
            )}
            {_formatted && _formatted.cas_number && (
              <span className="cas-number" dangerouslySetInnerHTML={{ __html: _formatted.cas_number }}></span>
            )}
            {_formatted && _formatted.body && (
              <span className="body" dangerouslySetInnerHTML={{ __html: _formatted.body }}></span>
            )}
            {!!(price && price !== '0' && price !== 0) && (
              <div className="price">
                <span>
                  {numberWithCommas(price)}
                  <span className="price-unit">원</span>
                </span>
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default SearchResultItem;



// WEBPACK FOOTER //
// ./src/components/search/SearchResultItem/SearchResultItem.js